export default {
  GET_TAKEAWAY_FACTOR_LOADING: 'GET_TAKEAWAY_FACTOR_LOADING',
  GET_TAKEAWAY_FACTOR_SUCCESS: 'GET_TAKEAWAY_FACTOR_SUCCESS',
  GET_TAKEAWAY_FACTOR_FAILED: 'GET_TAKEAWAY_FACTOR_FAILED',
  GET_TAKEAWAY_FACTOR_REJECT: 'GET_TAKEAWAY_FACTOR_REJECT',
};